import React, {Component} from 'react';
import PropTypes from 'prop-types';


export default class LabelRow extends Component {

	static propTypes = {
		isIgnored: PropTypes.bool,
		rowKey: PropTypes.number,
		label: PropTypes.object,
		isChecked: PropTypes.bool,
		updateNewSelection: PropTypes.func,
		toggleIgnoreScannedLabel: PropTypes.func,
		isRunning: PropTypes.bool,
		git: PropTypes.string,
		sourceBranch: PropTypes.string,
	};

	render() {

		const {rowKey, label, isChecked, isRunning, git, sourceBranch} = this.props;

		return (
			<tr className={'testcafe-labelId-' + label.name} key={rowKey}>
				{this.props.isIgnored ? null : (
					<td>
						<div className="form-check xpull-left">
							<label className="form-check-label">
								<input name="newNotIgnored" type="checkbox"
									   id={label.identifier}
									   checked={isChecked}
									   onChange={this.props.updateNewSelection}/>
								<span className="form-check-sign"/>
							</label>
						</div>
					</td>
				)}
				<th>
					<button
						disabled={isRunning}
						className="btn btn-outline-default btn-round btn-icon"
						onClick={() => this.props.toggleIgnoreScannedLabel(label, rowKey)}
					>
						<span className="btn-label">
							<i className="nc-icon nc-lock-circle-open"/>
						</span>
					</button>
				</th>
				<td>
					<small
						title={label.scannedLabelCollection.identifier}>{label.scannedLabelCollection.identifier.split(':').splice(-1)}</small>
				</td>
				<td>{label.name}</td>
				<td>{label.defaultValue}</td>
				<td>
					<small><a
						className="btn btn-link"
						href={"https://" + git.split(".git")[0].replace(":", "/") + "/tree/" + sourceBranch + "/" + label.importLocations[0].filePath + "#L" + label.importLocations[0].lineNumber}
						target="_blank">{label.name}:{label.importLocations[0].lineNumber}</a></small>
				</td>
			</tr>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/LabelRow.js